module.exports = __webpack_public_path__ + "img/pegas-logo.80959d98.webp";